module.exports = __webpack_public_path__ + "img/18.e05df272.png";